/* eslint-disable react/jsx-max-props-per-line */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Stack, Typography } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import validate from 'validate.js';
import { DialogDefaultV2, UsuarioSelectV2 } from '../../../components/v2';

const UsuarioModal = ({
  open,
  handlerCancel,
  handlerConfirm,
  usuarioId,
  message,
  grupos,
  isDigitador,
}) => {
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({ usuario: null });

  useEffect(() => {
    if (usuarioId) setValues({ usuario: usuarioId });
  }, [usuarioId]);

  const clearForm = () => {
    setErrors({});
    setValues({ usuario: null });
  };

  const onCancelLocal = () => {
    clearForm();
    handlerCancel();
  };

  const onConfirmLocal = () => {
    const validationErrors = validate(values, {
      usuario: {
        presence: { allowEmpty: false, message: 'é obrigatório' },
      },
    });
    setErrors(validationErrors || {});
    if (!validationErrors || Object.keys(validationErrors).length === 0) {
      clearForm();
      handlerConfirm(values.usuario);
    }
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onCancelLocal}
      handlerConfirm={onConfirmLocal}
      title={isDigitador ? 'Vincular Digitador' : 'Vincular Inspetor'}
      confirmMessage="Salvar"
      maxWidth="md"
    >
      <Grid container spacing={1} sx={{ pt: 1 }}>
        <Grid size={{ xs: 12 }}>
          <UsuarioSelectV2
            grupos={grupos}
            isRequired
            ativo
            label={isDigitador ? 'Digitador' : 'Inspetor'}
            error={!!(errors && errors.usuario)}
            onSelect={(usuario) => setValues({ usuario })}
            value={values.usuario}
          />
        </Grid>
        {usuarioId && message && (
          <Grid size={{ xs: 12 }}>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ pt: 1, pl: 0.5 }}>
              <WarningAmberOutlinedIcon color="error" fontSize="small" />
              <Typography variant="body2" color="error">
                {message}
              </Typography>
            </Stack>
          </Grid>
        )}
      </Grid>
    </DialogDefaultV2>
  );
};

UsuarioModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handlerCancel: PropTypes.func.isRequired,
  handlerConfirm: PropTypes.func.isRequired,
  usuarioId: PropTypes.string,
  message: PropTypes.string,
  grupos: PropTypes.array.isRequired,
  isDigitador: PropTypes.bool,
};

UsuarioModal.defaultProps = {
  usuarioId: null,
  message: null,
  isDigitador: true,
};

export default UsuarioModal;
